import {
    SET_TABLE_FILTER_CACHE,
    CLEAR_TABLE_FILTER_CACHE,
    CLEAR_ALL_TABLE_FILTER_CACHE
  } from './tableFilter.constants';
  
  export const setTableFilterCache = (route, filters) => ({
    type: SET_TABLE_FILTER_CACHE,
    payload: { route, filters }
  });
  
  export const clearTableFilterCache = (route) => ({
    type: CLEAR_TABLE_FILTER_CACHE,
    payload: { route }
  });
  
  export const clearAllTableFilterCache = () => ({
    type: CLEAR_ALL_TABLE_FILTER_CACHE
  });
  